import type { Locale } from "@/i18n/locales"

interface CurrencyFormatOptions {
  locale: Locale
  currency: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  currencyDisplay?: Intl.NumberFormatOptions["currencyDisplay"]
}

const formatters = new Map<string, Intl.NumberFormat>()

export const currencyFormatter = ({ locale, currency, minimumFractionDigits, maximumFractionDigits, currencyDisplay }: CurrencyFormatOptions): Intl.NumberFormat => {
  const key = `${locale}|${currency}|${minimumFractionDigits}|${maximumFractionDigits}|${currencyDisplay}`
  const cached = formatters.get(key)
  if (cached) return cached
  const formatter = new Intl.NumberFormat(locale, { style: "currency", currency, minimumFractionDigits, maximumFractionDigits, currencyDisplay })
  formatters.set(key, formatter)
  return formatter
}

const bareDollar = new Map<string, boolean>()

export const rendersBareDollar = (locale: Locale, currency: string): boolean => {
  const key = `${locale}|${currency}`
  const cached = bareDollar.get(key)
  if (cached !== undefined) return cached
  const bare = currencyFormatter({ locale, currency })
    .formatToParts(0)
    .some((part) => part.type === "currency" && part.value === "$")
  bareDollar.set(key, bare)
  return bare
}
